export enum IncidentArea {
    BackCountry = 1,
    CultivatedLand = 2,
    Fields = 3,
    Fence = 4
}
